document.addEventListener('click', function (event) {

  const zoomIcon = event.target.closest('.js-trigger-gallery-image')

  if (!zoomIcon) return

  const slide = zoomIcon.closest('.swiper-slide')

  const imageLink = slide?.querySelector('.product-media-gallery-image-click')

  if (!imageLink) return

  event.preventDefault()

  imageLink.click()

})
document.addEventListener('click', function (event) {
  const lightboxOpen = document.querySelector('.glightbox-open')

  if (!lightboxOpen) return

  const container = event.target.closest('.gcontainer')
  const content = event.target.closest('.gslide-media, .gslide-description, .gclose, .gnext, .gprev')

  if (container && !content) {
    const closeBtn = document.querySelector('.gclose')

    if (closeBtn) {
      closeBtn.click()
    }
  }
}, true)